import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  changePower,
  updateUnit,
  getProducts,
} from "../../store/reducers/filterSlice";
import { withTranslation } from "react-i18next";

class Allunits extends React.Component {
  state = {};

  constructor(props) {
    super(props);

    this.changeUnit = (unit, option) => {
      console.log(this.props.powers);
      if (unit.class != this.props.selectedClass) {
        const frequency = this.props.powers[unit.class][0].value;

        this.props.changePower({
          class: unit.class,
          frequency: [frequency],
        });
      }

      this.props.updateUnit({
        option: option,
        unit: unit.unit,
        // from: unit.min,
        // to: unit.max
      });
    };

    this.isSelectedUnit = (unit, option) => {
      if (
        !!this.props.selectedRange[option] &&
        this.props.selectedRange[option].unit == unit
      ) {
        return true;
      }

      return false;
    };

    this.getPowerTypeLabel = (powerClass) => {
      switch (powerClass) {
        case "metricISO":
          return this.props.t
            ? this.props.t("Standard International (SI)")
            : "AC";
        case "metricUS":
          return this.props.t ? this.props.t("US Standard (US)") : "DC";
        default:
          return powerClass;
      }
    };
  }

  render() {
    const { t } = this.props;
    return (
      <>
        {this.props.ranges.map((range) => (
          <div className="row">
            <div className="column">
              <h5>{range.title}</h5>
            </div>
            {Object.entries(range.classes).map((classEntry, i) => (
              <div
                key={classEntry[1].class}
                className="column"
                data-class={classEntry[1].class}
              >
                <div className="type">
                  {this.getPowerTypeLabel(classEntry[1].class)}
                </div>
                <div className="buttons">
                  {classEntry[1].units.map((unit, j) => (
                    <button
                      key={j + i}
                      data-tes={classEntry[1].class + i}
                      className={
                        this.isSelectedUnit(unit.unit, range.option)
                          ? "selected"
                          : ""
                      }
                      onClick={(e) => {
                        this.changeUnit(unit, range.option);
                      }}
                    >
                      {unit.unit}
                    </button>
                  ))}
                </div>
              </div>
            ))}
          </div>
        ))}

        {/* <div className="row">
                    <div className="column">
                        <h5>{t('Power supply/Unit')}</h5>
                    </div>
                    {
                        Object.entries(this.props.powers).map((power, i) =>
                            <div key={power[0]} className="column" data-class={power[0]}>
                                <div className="type">
                                    {this.getPowerTypeLabel(power[0])}
                                </div>
                                <div className='buttons'>
                                    {
                                        power[1].map((frequency, j) =>
                                            <button key={(j + i)} data-tes={power[0] + i} className={"power" + (this.buttonIsSelected(power[0], frequency.value) ? " selected" : "")} onClick={this.powerChanged(power[0], frequency.value)}>{frequency.value}</button>
                                        )
                                    }
                                </div>
                            </div>
                        )
                    }
                </div> */}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    selectedClass: state.filter.request.class,
    frequency: state.filter.request.frequency,
    ranges: state.filter.filter.ranges,
    selectedRange: state.filter.request.range,
    powers: state.filter.filter.powers,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      updateUnit: (args) => (dispatch) => {
        dispatch(updateUnit(args));
        dispatch(getProducts());
      },
      changePower: (args) => (dispatch) => {
        dispatch(changePower(args));
      },
    },
    dispatch
  );
};

// const mapDispatchToProps = dispatch => {
//     return bindActionCreators({
//         changePower: args => dispatch => {
//             dispatch(changePower(args));
//             dispatch(getProducts());
//         }
//     }, dispatch);
// };

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(Allunits));
